module.exports = __webpack_public_path__ + "static/media/pp-cov.de03af49.jpg";